import {
  Component,
  Input,
  Output,
  EventEmitter,
  ViewEncapsulation,
  HostBinding,
  OnChanges
} from '@angular/core';
import { STATUSES } from '../tracking-page-item';
import {
  TrackingPageFont,
  TrackingPageSidebar
} from '../../tracking-page.model';
import { MediaMatcher } from '@angular/cdk/layout';
import { OnInit } from '@angular/core';

@Component({
  selector: 'app-tracking-page-sidebar',
  templateUrl: './tracking-page-sidebar.component.html',
  styleUrls: ['./tracking-page-sidebar.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class TrackingPageSidebarComponent implements OnInit, OnChanges {
  @Input() sideBarItems: any[];
  @Input() sidebar: TrackingPageSidebar;
  @Input() sideBarItemsOpened: any[];
  @Input() showMoreSideBarItems: boolean;
  @Input() moreValues: number;
  @Input() font: TrackingPageFont;
  @Input() selectedItem: any;
  @Input() sidebarOpened: boolean;
  @Input() selectedId: any;
  @Input() loadMoreVisible: boolean;
  @Output() toggleSideBarItemOpen = new EventEmitter();
  @Output() selectTrackingNumber = new EventEmitter();
  @Output() showMore = new EventEmitter();
  @Output() toggleSidebar = new EventEmitter();
  @Output() selectBlock = new EventEmitter();

  @HostBinding('class') opened: string;
  items: any;
  public readonly statuses = STATUSES;

  mobileQuery;

  constructor(private media: MediaMatcher) {}

  triggerToggleSideBarOpen(id) {
    if (
      this.items.length > 1 &&
      ((this.sideBarItemsOpened.includes(id) &&
        this.sideBarItemsOpened.length > 1) ||
        !this.sideBarItemsOpened.includes(id))
    ) {
      this.toggleSideBarItemOpen.emit({
        id,
        open: this.sideBarItemsOpened.includes(id)
      });
    }
  }

  ngOnInit() {
    this.mobileQuery = this.media.matchMedia(`(max-width: ${991}px)`);
  }

  ngOnChanges() {
    this.opened = this.sidebarOpened ? 'opened' : null;
    this.items = this.sideBarItems;
  }

  triggerSelectTrackingNumber(id) {
    this.selectTrackingNumber.emit(id);
    if (this.mobileQuery.matches) {
      this.toggleSidebar.emit();
    }
  }
}
